module.exports = __webpack_public_path__ + "img/x_white.1092570c.png";